import { EncryptionUserEntity } from '../entities/EncryptionUser';
import { authResource } from './Auth';
export const OrganizationEncryptionUserResource = authResource({
    path: '/organizations/:organizationId/encryptions/users',
    schema: EncryptionUserEntity
}).extend((BaseResource) => ({
    add: BaseResource.partialUpdate.extend({
        body: {},
        schema: undefined
    })
}));
